export const COSTUMER_LANGUAGES = [
  { value: "ita", label: "Italiano", icon: "🇮🇹" },
  { value: "de", label: "Deutsch", icon: "🇩🇪" }
];

export const COMPANY_COSTUMER_TYPE = "empresa";
export const INDIVIDUAL_COSTUMER_TYPE = "individual";

export const COSTUMER_TYPES = [
  { value: COMPANY_COSTUMER_TYPE, label: "Empresa" },
  { value: INDIVIDUAL_COSTUMER_TYPE, label: "Individual" }
];

export interface Costumer {
  id: string;
  name: string;
  address: string;
  fullAddress: string;
  phone: string;
  phone2: string;
  email: string;
  email2: string;
  email3: string;
  language: string;
  priceVersion: number;
  createdAt: Date;
  updatedAt: Date;
  isCompany?: boolean;
}

export interface CostumerForm {
  name: string;
  phone: string;
  phone2: string;
  email: string;
  address: string;
  fullAddress: string;
  language: string;
  isCompany: boolean;
  pricePerWorkHour: number;
}

export interface PericiaCostumer extends Pick<Costumer, "id" | "name" | "language"> {}

export interface CostumerUpdate extends CostumerForm {
  id: string;
}

export interface CostumerRepositoryUpdate extends Omit<CostumerForm, "fullAddress" | "isCompany" | "pricePerWorkHour"> {
  id: string;
  full_address: string;
  is_company: boolean;
  price_per_working_hour: number;
}

export interface CostumerRepositoryInsert {
  name: string;
  phone: string;
  phone2: string;
  email: string;
  email2: string;
  email3: string;
  address: string;
  full_address: string;
  is_company: boolean;
  price_per_working_hour: number;
}

export interface CostumerRepositoryGet {
  id: string;
  name: string;
  phone: string;
  phone2: string;
  email: string;
  email2: string;
  email3: string;
  address: string;
  full_address: string;
  is_company: boolean;
  price_per_working_hour: number;
  price_version: number;
  created_at: Date;
  updated_at: Date;
  language: string;
}

export function CreateNewCostumer(override?: Partial<Costumer>): Costumer {
  return {
    id: "",
    name: "",
    address: "",
    fullAddress: "",
    phone: "",
    phone2: "",
    email: "",
    email2: "",
    email3: "",
    language: "",
    priceVersion: 2,
    createdAt: new Date(),
    updatedAt: new Date(),
    ...override
  };
}

export function isValidCostumer(costumer: Costumer): boolean {
  return (
    costumer.name !== "" &&
    costumer.address !== "" &&
    costumer.fullAddress !== "" &&
    costumer.phone !== "" &&
    costumer.email !== "" &&
    costumer.language !== ""
  );
}
